/**
 * @fileoverview Outreach Vuex module for managing contacts, tags, stages, and metrics.
 * @module store/modules/outreach
 *
 * This module provides functionality for:
 * - Managing outreach contacts and their attributes
 * - Creating and applying tags and stages for segmentation
 * - Tracking metrics with filter groups
 * - Filtering and sorting contact lists
 * - Managing automation campaigns
 */

import { RootState } from "@/store/types";
import { Module } from "vuex";
import { OutreachState } from "./types";
import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";
import state from "./state";
const outreach: Module<OutreachState, RootState> = {
  // namespaced: true,
  actions,
  getters,
  mutations,
  state,
};
export default outreach;
